// Country phone codes with formatting information
export const countryPhoneCodes = [
  { country: 'AF', code: '+93', name: 'Afghanistan' },
  { country: 'AL', code: '+355', name: 'Albania' },
  { country: 'DZ', code: '+213', name: 'Algeria' },
  { country: 'AD', code: '+376', name: 'Andorra' },
  { country: 'AO', code: '+244', name: 'Angola' },
  { country: 'AG', code: '+1268', name: 'Antigua and Barbuda' },
  { country: 'AR', code: '+54', name: 'Argentina' },
  { country: 'AM', code: '+374', name: 'Armenia' },
  { country: 'AU', code: '+61', name: 'Australia' },
  { country: 'AT', code: '+43', name: 'Austria' },
  { country: 'AZ', code: '+994', name: 'Azerbaijan' },
  { country: 'BS', code: '+1242', name: 'Bahamas' },
  { country: 'BH', code: '+973', name: 'Bahrain' },
  { country: 'BD', code: '+880', name: 'Bangladesh' },
  { country: 'BB', code: '+1246', name: 'Barbados' },
  { country: 'BY', code: '+375', name: 'Belarus' },
  { country: 'BE', code: '+32', name: 'Belgium' },
  { country: 'BZ', code: '+501', name: 'Belize' },
  { country: 'BJ', code: '+229', name: 'Benin' },
  { country: 'BT', code: '+975', name: 'Bhutan' },
  { country: 'BO', code: '+591', name: 'Bolivia' },
  { country: 'BA', code: '+387', name: 'Bosnia and Herzegovina' },
  { country: 'BW', code: '+267', name: 'Botswana' },
  { country: 'BR', code: '+55', name: 'Brazil' },
  { country: 'BN', code: '+673', name: 'Brunei' },
  { country: 'BG', code: '+359', name: 'Bulgaria' },
  { country: 'BF', code: '+226', name: 'Burkina Faso' },
  { country: 'BI', code: '+257', name: 'Burundi' },
  { country: 'CV', code: '+238', name: 'Cabo Verde' },
  { country: 'KH', code: '+855', name: 'Cambodia' },
  { country: 'CM', code: '+237', name: 'Cameroon' },
  { country: 'CA', code: '+1', name: 'Canada' },
  { country: 'CF', code: '+236', name: 'Central African Republic' },
  { country: 'TD', code: '+235', name: 'Chad' },
  { country: 'CL', code: '+56', name: 'Chile' },
  { country: 'CN', code: '+86', name: 'China' },
  { country: 'CO', code: '+57', name: 'Colombia' },
  { country: 'KM', code: '+269', name: 'Comoros' },
  { country: 'CG', code: '+242', name: 'Congo' },
  { country: 'CR', code: '+506', name: 'Costa Rica' },
  { country: 'HR', code: '+385', name: 'Croatia' },
  { country: 'CU', code: '+53', name: 'Cuba' },
  { country: 'CY', code: '+357', name: 'Cyprus' },
  { country: 'CZ', code: '+420', name: 'Czech Republic' },
  { country: 'CD', code: '+243', name: 'Democratic Republic of the Congo' },
  { country: 'DK', code: '+45', name: 'Denmark' },
  { country: 'DJ', code: '+253', name: 'Djibouti' },
  { country: 'DM', code: '+1767', name: 'Dominica' },
  { country: 'DO', code: '+1809', name: 'Dominican Republic' },
  { country: 'EC', code: '+593', name: 'Ecuador' },
  { country: 'EG', code: '+20', name: 'Egypt' },
  { country: 'SV', code: '+503', name: 'El Salvador' },
  { country: 'GQ', code: '+240', name: 'Equatorial Guinea' },
  { country: 'ER', code: '+291', name: 'Eritrea' },
  { country: 'EE', code: '+372', name: 'Estonia' },
  { country: 'ET', code: '+251', name: 'Ethiopia' },
  { country: 'FJ', code: '+679', name: 'Fiji' },
  { country: 'FI', code: '+358', name: 'Finland' },
  { country: 'FR', code: '+33', name: 'France' },
  { country: 'GA', code: '+241', name: 'Gabon' },
  { country: 'GM', code: '+220', name: 'Gambia' },
  { country: 'GE', code: '+995', name: 'Georgia' },
  { country: 'DE', code: '+49', name: 'Germany' },
  { country: 'GH', code: '+233', name: 'Ghana' },
  { country: 'GR', code: '+30', name: 'Greece' },
  { country: 'GD', code: '+1473', name: 'Grenada' },
  { country: 'GT', code: '+502', name: 'Guatemala' },
  { country: 'GN', code: '+224', name: 'Guinea' },
  { country: 'GW', code: '+245', name: 'Guinea-Bissau' },
  { country: 'GY', code: '+592', name: 'Guyana' },
  { country: 'HT', code: '+509', name: 'Haiti' },
  { country: 'HN', code: '+504', name: 'Honduras' },
  { country: 'HU', code: '+36', name: 'Hungary' },
  { country: 'IS', code: '+354', name: 'Iceland' },
  { country: 'IN', code: '+91', name: 'India' },
  { country: 'ID', code: '+62', name: 'Indonesia' },
  { country: 'IR', code: '+98', name: 'Iran' },
  { country: 'IQ', code: '+964', name: 'Iraq' },
  { country: 'IE', code: '+353', name: 'Ireland' },
  { country: 'IL', code: '+972', name: 'Israel' },
  { country: 'IT', code: '+39', name: 'Italy' },
  { country: 'JM', code: '+1876', name: 'Jamaica' },
  { country: 'JP', code: '+81', name: 'Japan' },
  { country: 'JO', code: '+962', name: 'Jordan' },
  { country: 'KZ', code: '+7', name: 'Kazakhstan' },
  { country: 'KE', code: '+254', name: 'Kenya' },
  { country: 'KI', code: '+686', name: 'Kiribati' },
  { country: 'KP', code: '+850', name: 'North Korea' },
  { country: 'KR', code: '+82', name: 'South Korea' },
  { country: 'KW', code: '+965', name: 'Kuwait' },
  { country: 'KG', code: '+996', name: 'Kyrgyzstan' },
  { country: 'LA', code: '+856', name: 'Laos' },
  { country: 'LV', code: '+371', name: 'Latvia' },
  { country: 'LB', code: '+961', name: 'Lebanon' },
  { country: 'LS', code: '+266', name: 'Lesotho' },
  { country: 'LR', code: '+231', name: 'Liberia' },
  { country: 'LY', code: '+218', name: 'Libya' },
  { country: 'LI', code: '+423', name: 'Liechtenstein' },
  { country: 'LT', code: '+370', name: 'Lithuania' },
  { country: 'LU', code: '+352', name: 'Luxembourg' },
  { country: 'MG', code: '+261', name: 'Madagascar' },
  { country: 'MW', code: '+265', name: 'Malawi' },
  { country: 'MY', code: '+60', name: 'Malaysia' },
  { country: 'MV', code: '+960', name: 'Maldives' },
  { country: 'ML', code: '+223', name: 'Mali' },
  { country: 'MT', code: '+356', name: 'Malta' },
  { country: 'MH', code: '+692', name: 'Marshall Islands' },
  { country: 'MR', code: '+222', name: 'Mauritania' },
  { country: 'MU', code: '+230', name: 'Mauritius' },
  { country: 'MX', code: '+52', name: 'Mexico' },
  { country: 'FM', code: '+691', name: 'Micronesia' },
  { country: 'MD', code: '+373', name: 'Moldova' },
  { country: 'MC', code: '+377', name: 'Monaco' },
  { country: 'MN', code: '+976', name: 'Mongolia' },
  { country: 'ME', code: '+382', name: 'Montenegro' },
  { country: 'MA', code: '+212', name: 'Morocco' },
  { country: 'MZ', code: '+258', name: 'Mozambique' },
  { country: 'MM', code: '+95', name: 'Myanmar' },
  { country: 'NA', code: '+264', name: 'Namibia' },
  { country: 'NR', code: '+674', name: 'Nauru' },
  { country: 'NP', code: '+977', name: 'Nepal' },
  { country: 'NL', code: '+31', name: 'Netherlands' },
  { country: 'NZ', code: '+64', name: 'New Zealand' },
  { country: 'NI', code: '+505', name: 'Nicaragua' },
  { country: 'NE', code: '+227', name: 'Niger' },
  { country: 'NG', code: '+234', name: 'Nigeria' },
  { country: 'MK', code: '+389', name: 'North Macedonia' },
  { country: 'NO', code: '+47', name: 'Norway' },
  { country: 'OM', code: '+968', name: 'Oman' },
  { country: 'PK', code: '+92', name: 'Pakistan' },
  { country: 'PW', code: '+680', name: 'Palau' },
  { country: 'PA', code: '+507', name: 'Panama' },
  { country: 'PG', code: '+675', name: 'Papua New Guinea' },
  { country: 'PY', code: '+595', name: 'Paraguay' },
  { country: 'PE', code: '+51', name: 'Peru' },
  { country: 'PH', code: '+63', name: 'Philippines' },
  { country: 'PL', code: '+48', name: 'Poland' },
  { country: 'PT', code: '+351', name: 'Portugal' },
  { country: 'QA', code: '+974', name: 'Qatar' },
  { country: 'RO', code: '+40', name: 'Romania' },
  { country: 'RU', code: '+7', name: 'Russia' },
  { country: 'RW', code: '+250', name: 'Rwanda' },
  { country: 'KN', code: '+1869', name: 'Saint Kitts and Nevis' },
  { country: 'LC', code: '+1758', name: 'Saint Lucia' },
  { country: 'VC', code: '+1784', name: 'Saint Vincent and the Grenadines' },
  { country: 'WS', code: '+685', name: 'Samoa' },
  { country: 'SM', code: '+378', name: 'San Marino' },
  { country: 'ST', code: '+239', name: 'Sao Tome and Principe' },
  { country: 'SA', code: '+966', name: 'Saudi Arabia' },
  { country: 'SN', code: '+221', name: 'Senegal' },
  { country: 'RS', code: '+381', name: 'Serbia' },
  { country: 'SC', code: '+248', name: 'Seychelles' },
  { country: 'SL', code: '+232', name: 'Sierra Leone' },
  { country: 'SG', code: '+65', name: 'Singapore' },
  { country: 'SK', code: '+421', name: 'Slovakia' },
  { country: 'SI', code: '+386', name: 'Slovenia' },
  { country: 'SB', code: '+677', name: 'Solomon Islands' },
  { country: 'SO', code: '+252', name: 'Somalia' },
  { country: 'ZA', code: '+27', name: 'South Africa' },
  { country: 'SS', code: '+211', name: 'South Sudan' },
  { country: 'ES', code: '+34', name: 'Spain' },
  { country: 'LK', code: '+94', name: 'Sri Lanka' },
  { country: 'SD', code: '+249', name: 'Sudan' },
  { country: 'SR', code: '+597', name: 'Suriname' },
  { country: 'SZ', code: '+268', name: 'Eswatini' },
  { country: 'SE', code: '+46', name: 'Sweden' },
  { country: 'CH', code: '+41', name: 'Switzerland' },
  { country: 'SY', code: '+963', name: 'Syria' },
  { country: 'TW', code: '+886', name: 'Taiwan' },
  { country: 'TJ', code: '+992', name: 'Tajikistan' },
  { country: 'TZ', code: '+255', name: 'Tanzania' },
  { country: 'TH', code: '+66', name: 'Thailand' },
  { country: 'TL', code: '+670', name: 'Timor-Leste' },
  { country: 'TG', code: '+228', name: 'Togo' },
  { country: 'TO', code: '+676', name: 'Tonga' },
  { country: 'TT', code: '+1868', name: 'Trinidad and Tobago' },
  { country: 'TN', code: '+216', name: 'Tunisia' },
  { country: 'TR', code: '+90', name: 'Turkey' },
  { country: 'TM', code: '+993', name: 'Turkmenistan' },
  { country: 'TV', code: '+688', name: 'Tuvalu' },
  { country: 'UG', code: '+256', name: 'Uganda' },
  { country: 'UA', code: '+380', name: 'Ukraine' },
  { country: 'AE', code: '+971', name: 'United Arab Emirates' },
  { country: 'GB', code: '+44', name: 'United Kingdom' },
  { country: 'US', code: '+1', name: 'United States' },
  { country: 'UY', code: '+598', name: 'Uruguay' },
  { country: 'UZ', code: '+998', name: 'Uzbekistan' },
  { country: 'VU', code: '+678', name: 'Vanuatu' },
  { country: 'VA', code: '+379', name: 'Vatican City' },
  { country: 'VE', code: '+58', name: 'Venezuela' },
  { country: 'VN', code: '+84', name: 'Vietnam' },
  { country: 'YE', code: '+967', name: 'Yemen' },
  { country: 'ZM', code: '+260', name: 'Zambia' },
  { country: 'ZW', code: '+263', name: 'Zimbabwe' }
];

// Utility functions
export const getPhoneCode = (countryCode) => {
  const phoneInfo = countryPhoneCodes.find(p => p.country === countryCode);
  return phoneInfo ? phoneInfo.code : '';
};

export const getPhoneCodeWithName = (countryCode) => {
  const phoneInfo = countryPhoneCodes.find(p => p.country === countryCode);
  return phoneInfo ? { code: phoneInfo.code, name: phoneInfo.name } : null;
};

export const formatPhoneNumber = (countryCode, phoneNumber) => {
  const phoneCode = getPhoneCode(countryCode);
  if (!phoneCode || !phoneNumber) return phoneNumber;
  
  // If the phone number already starts with the country code, return as is
  if (phoneNumber.startsWith(phoneCode)) {
    return phoneNumber;
  }
  
  // If the phone number starts with a different country code, remove it
  const cleanNumber = phoneNumber.replace(/^\+?\d{1,4}/, '');
  
  // If the clean number is empty, return empty
  if (!cleanNumber.trim()) {
    return '';
  }
  
  // Return formatted number with country code
  return `${phoneCode} ${cleanNumber}`;
};

export const getPhonePlaceholder = (countryCode) => {
  const phoneCode = getPhoneCode(countryCode);
  if (!phoneCode) return 'Enter phone number';
  
  // Return appropriate placeholder based on country
  switch (countryCode) {
    case 'IN': // India
      return `98765 43210`;
    case 'US': // United States
      return `(555) 123-4567`;
    case 'GB': // United Kingdom
      return `7700 900000`;
    case 'CA': // Canada
      return `(555) 123-4567`;
    case 'AU': // Australia
      return `412 345 678`;
    default:
      return `Enter phone number`;
  }
}; 